import React from 'react';
import Tooltip from '@mui/material/Tooltip';

/*
params @title
        title or text for the tooltip
params @placement
        position to place the tooltip
params @open
        if true, tooltip will open
params @children
        components inside this custom component
*/
const MuiNavTooltip = ({ title, placement, open, children }) => {
    return (
        <Tooltip
            sx={{ zIndex: 100 }}
            arrow
            title={title}
            placement={placement}
            open={open}
            componentsProps={{
                tooltip: {
                    sx: {
                        bgcolor: '#d37536 ',
                        '& .MuiTooltip-arrow': {
                            color: '#d37536 ',
                            fontSize: '15px'
                        },
                        fontSize: '16px',
                        fontFamily: 'Josefin Sans',
                        py: '15px',
                        px: '20px',
                        borderRadius: '10px'
                    },
                },
            }}
        >
            {children}
        </Tooltip>
    );
};

export default MuiNavTooltip;